module.exports = __webpack_public_path__ + "static/media/Used Cat Forestry Machines - Toromont Cat.804e90b6.jpg";